import React, { Component }  from 'react'
import { connect } from 'react-redux'
import Numeral from 'numeral'

import CommonTable from './CommonTable'
import { Column } from 'react-virtualized'
import Badge from 'components/Badge'
import PropertyStatusIcon from './StatusIcon'
import {properties, owners} from 'selectors/entities'
import { propertiesLLTable } from 'selectors/propertiesTable'
import { incomeStatementYTD } from 'selectors/transactions'

import calcTable from 'utils/calcTable'

const colors = {
	"For Rent": "#BA68C8",
	"Occupied": "#39cea8",
	"Retired": "#A0A0A0",
	"Out Of Service": "#000",
	"Not in Service": "#000"
}

let select = (state) => ({
	properties: propertiesLLTable(state)
})

export class PropertiesTable extends Component{
	render(){
		let { props } = this
		let cols = {
			alias: {min:150, avg:200}
		, status: 35
		, income: {min:100, avg:110}
		, rent: {min:100, avg:200}
		}
		cols = calcTable(props.width, cols)
		return(
			<CommonTable entity="property" data={props.properties}>
				<Column
					width={cols.status}
					label=""
					dataKey='status'
					flexShrink={0}
					cellRenderer={
					  ({ rowData }) => (<div style={{position:"relative", top:"5px", left:"-8px"}}><PropertyStatusIcon id={rowData._id} status={rowData.status} /></div>)
					}
				/>
				<Column
				  width={cols.alias}
				  label='Property'
				  dataKey='alias'
					cellRenderer={({ rowData }) => <span style={{fontWeight: rowData._id?"400":"800"}}>{rowData.alias}</span> }
				/>
				{cols.rent && <Column
					width={cols.rent}
					style={{textAlign:"right"}}
					headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px"}}>Rent/Mo</div>}
					dataKey='rent'
					cellRenderer={({ rowData }) => <div style={{fontWeight: rowData._id?"400":"800"}}>{(rowData.rent<0 && '-' || '')+'$'+ Numeral(Math.abs(rowData.rent)).format('0,0')}</div> }
				/>}
				{cols.income && <Column
					width={cols.income}
					dataKey='income'
					style={{textAlign:"right"}}
					headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px"}}>Net Income YTM</div>}
					cellRenderer={({ rowData }) => <div style={{fontWeight: rowData._id?"400":"800", color: rowData.income < 0 ? 'red' : '#000'}}>{(rowData.income<0 &&'-' || '')+'$'+ Numeral(Math.abs(rowData.income)).format('0,0')}</div> }
				/>}
		  </CommonTable>
		)
	}
}
export default connect(select)(PropertiesTable)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/Table.js